import { z } from 'zod';

export const FormSchema = z.object({
  rg_code: z.string().nonempty('Mã khu vực là bắt buộc'),
  rgname: z.string().nonempty('Tên khu vực là bắt buộc'),
  rgname2: z.string().optional(),
  stt: z.coerce.number().min(0, 'Số thứ tự không được âm').optional(),
  status: z.string().nonempty('Trạng thái là bắt buộc')
});

export type FormValues = z.infer<typeof FormSchema>;

export const initialFormValues: FormValues = {
  rg_code: '',
  rgname: '',
  rgname2: '',
  stt: 0,
  status: '1'
};
